import { render, staticRenderFns } from "./Divulgador.vue?vue&type=template&id=2b827e5b"
import script from "./Divulgador.vue?vue&type=script&lang=js"
export * from "./Divulgador.vue?vue&type=script&lang=js"
import style0 from "./Divulgador.vue?vue&type=style&index=0&id=2b827e5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports